<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    侨城东站<br>
站点介绍<br>
侨城东站位于侨城东路以西小沙河路以东的深南大道下。北侧是华侨城住宅区，东北角有一栋高层写字楼，南侧是新浩城商住楼，东端是侨城东路立交桥，西南侧为己建成的锦绣中华旅游风景区。侨城东站装修设计与地面西南侧锦绣中华旅游风景区协调，体现“花园中建城市的独特城市环境特色，采用天兰＋浅绿色彩基调。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:05	23:42	1号线	2分钟	4分40秒<br>
机场东	06:00	23:26	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:32	23:41	1号线	3分45秒	5分45秒<br>
机场东	06:16	23:25	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:32	00:41	1号线	3分45秒	5分45秒<br>
机场东	06:16	00:25	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
深南大道北侧、侨城东路（南）、深圳市公安局警察训练学校、深圳国际园林花卉博览园、OCT当代艺术中心（华侨城创意文化园）、深圳高级技工学校、合纵音乐学院<br><br>
B出入口:<br>
深南大道南侧（东）、碧海云天、新浩城花园、金海燕花园<br><br>
C1出入口:<br>
侨城东路（东）、深圳地铁竹子林车辆段、深圳地铁侨城东车辆段、红树林自然保护区、香港大学深圳医院、金海燕花园<br><br>
C2出入口:<br>
深南大道南侧（西）、侨城东路（东南）<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 侨城东地铁站<br>
21、26、369、433、M132、M487<br><br>
A出入口:<br>
公交站名： 侨城东地铁接驳站<br>
B665<br><br>
B出入口:<br>
公交站名： 侨城东地铁站<br>
21、26、369、433、M132、M487<br><br>
C1出入口:<br>
公交站名： 金海燕花园<br>
369、M312、M487、M561、M392<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>





